import Icon, { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Layout } from 'antd';
import React from "react";
import mainLogo from "./components/common/main-logo";
import './header.css';
import { useStore } from "./stores/root-store";

const Header: React.FC = () => {

    const { authStore } = useStore();

    const handleLogout = () => {
        authStore.logout();
    }

    return (
        <Layout.Header style={{ minHeight: '7vh' }}>
            <Button
                type="link"
                icon={<Icon component={mainLogo.light} />}
                href="/"
                className="logo__button"
            />
            <div className="profile__button">
                <Button type="primary"
                    shape="circle"
                    icon={<UserOutlined />}
                    title="Профиль"
                    href="/profile" />
                <Button type="primary"
                    shape="circle"
                    icon={<LogoutOutlined />}
                    title="Выход"
                    onClick={handleLogout}
                    style={{ marginLeft: 10 }} />
            </div>
        </Layout.Header>
    );
};

export default Header;